import { render, staticRenderFns } from "./AddPcrRapidTest.vue?vue&type=template&id=0d218735&scoped=true&"
import script from "./AddPcrRapidTest.vue?vue&type=script&lang=js&"
export * from "./AddPcrRapidTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d218735",
  null
  
)

export default component.exports